import { Widget, WIDGET_GROUPRESULT } from "@gaming/srvg-classes-core";


export class GroupResultWidget extends Widget {
    widgetName: string;
    widget: any;
    onLoad: any;
    currentGroup: string;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#groupResultWidget';
        super( options );

        var self = this;
        this.onLoad = options.onLoad || function(widget) { self.setGroup(); };


        this.name = 'widgetgroupresult';
        this.widgetName = options.widgetName || WIDGET_GROUPRESULT;
        this.widgetName = this.product + this.widgetName;



        this.widget = null;

        this.widgetOptions = {
            // every widget needs a default height definition
            height: this.getContainerHeightWithUnit(),
        };

        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addGroupResultWidget();
        super.handleDomInstantiated();
    }

    /**
     * add livetable widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addGroupResultWidget(selector?) {
        if(!srvg.widgets.widgets['groupresult'].enabled){
            console.info("Widget is disabled", this.widgetName);
            return;
        }

        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions,
            this.onLoad
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addGroupResultWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addGroupResultWidget(element);
    }

    /**
     * calls widget api setGroup to set the group (match groups A - n, not widget group)
     * @param string with group
     * Group should be given in a string e.g. ('A').
     */
    setGroup(group?:string){
        group = group || this.currentGroup || null
        this.currentGroup = group;
        if(group && this.widget && this.widget.api && this.widget.api.setGroup){
            this.widget.api.setGroup(group);
        }
    }

}